<script>
    export let dynamic_scale;
    export let static_scale;
    export let horizontal;
    export let data=[]; // array of the object with keys { lower: ..., upper: ..., center: ..., static: ...}
    export let region;

    import GraphMarker from './GraphMarker.svelte';
</script>

<g class={`graph-points-group graph-points-group__${region}`}>
    {#each data as item}
        <GraphMarker 
            {horizontal}
            {region}
            striped={item.striped}
            min={item.lower ? dynamic_scale(item.lower) : null}
            min_label={item.lower === item.lod ? 'LOD' : item.lower}
            max={item.upper ? dynamic_scale(item.upper) : null}
            max_label={item.upper === item.lod ? 'LOD' : item.upper}
            center={item.center ? dynamic_scale(item.center) : null}
            center_label={item.center === item.lod ? 'LOD' : item.center}
            static_pos={static_scale(item.static)}
        />
    {/each}
</g>

<style>
    .graph-points-group__prairies {
        stroke: rgba(119,184,0,0.4);
        fill: rgb(113,149,0);
    }
    .graph-points-group__canada {
        stroke: rgba(0,170,210,0.3);
        fill: rgb(0,129,171);
    }
</style>